export const UPDATE_PICTURE_FEEDBACK = "UPDATE_PICTURE_FEEDBACK";
export const DELETE_PICTURE_FEEDBACK = "DELETE_PICTURE_FEEDBACK";

interface IUpdatePictureFeedbackAction {
  type: typeof UPDATE_PICTURE_FEEDBACK;
  payload: {
    pictureId: string;
    feedback: string;
    feedback_id: string;
  };
}

interface IDeletePictureFeedbackAction {
  type: typeof DELETE_PICTURE_FEEDBACK;
  payload: {
    pictureId: string;
  };
}

export type PictureFeedbackActionTypes =
  | IUpdatePictureFeedbackAction
  | IDeletePictureFeedbackAction;

export const updatePictureFeedback = (
  pictureId: string,
  feedback: string,
  feedback_id: string,
): IUpdatePictureFeedbackAction => ({
  type: UPDATE_PICTURE_FEEDBACK,
  payload: {
    pictureId,
    feedback,
    feedback_id,
  },
});

export const deletePictureFeedback = (
  pictureId: string,
): IDeletePictureFeedbackAction => ({
  type: DELETE_PICTURE_FEEDBACK,
  payload: {
    pictureId,
  },
});
